






















































































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import viewerService from '@/model/services/viewer-service';
import contentsService from '@/model/services/contents-service';
import userService from '@/model/services/user-service';
import {GCICategoryInfoRes, GCICategoryListRes, GCICategoryManageListRes} from '@/model/dto/res/contents/get-category-list-res';
import {PUCATDataReq, PostUpsertCategoryReq} from '@/model/dto/req/category/post-upsert-category-req';
import {GlobalConstants} from '@/common/constants';
import draggable from 'vuedraggable';
import _ from 'lodash';

@Component({
  components: {
    'draggable': draggable
  }
})
export default class CategoryManageViewer extends Vue {

  private selected: number[] = [0];
  private name: string = '';
  private type: string = '';
  private isDeleteIndex: number = 0;
  private lazy: boolean = true;
  private uniqName: boolean = true;
  private uniqType: boolean = true;
  private rules = {
    required: (value: string) => !!value || this.text.required,
    min: (v: string) => v.length >= this.text.minValue || this.text.minText,
    max: (v: string) => v.length <= this.text.maxValue || this.text.maxText,
    uniqName: (v: string) => {
      const check = _.filter(appModule.categoryManageInfo, {category_name: v});
      return check.length <= 1 ? true : this.text.uniq;
    },
    uniqType: (v: string) => {
      const check = _.filter(appModule.categoryManageInfo, {category_type: v});
      return check.length <= 1 ? true : this.text.uniq;
    },
    regex: (v: string) => {
      const check = /^[a-z_A-Z]+[0-9]*$/.test(v) || this.text.regex;
      return check;
    }
  };

  /** Data **/
  /** Computed **/
  get userId() {
    return userModule.userId;
  }

  get userName() {
    return userModule.userName;
  }

  set categoryInfo(val: GCICategoryManageListRes[]) {
    appModule.updateCategoryManageInfo(val);
  }

  get categoryInfo() {
    return appModule.categoryManageInfo;
  }

  get text() {
    return {
      title: GlobalConstants.TEXT.CATEGORYMANAGE.TITLE,
      label: GlobalConstants.TEXT.CATEGORYMANAGE.LABEL,
      key: GlobalConstants.TEXT.CATEGORYMANAGE.KEY,
      minValue: GlobalConstants.TEXT.CATEGORYMANAGE.MIN.VALUE,
      maxValue: GlobalConstants.TEXT.CATEGORYMANAGE.MAX.VALUE,
      minText: GlobalConstants.TEXT.CATEGORYMANAGE.MIN.TEXT,
      maxText: GlobalConstants.TEXT.CATEGORYMANAGE.MAX.TEXT,
      required: GlobalConstants.TEXT.CATEGORYMANAGE.REQUIRED,
      uniq: GlobalConstants.TEXT.CATEGORYMANAGE.UNIQ,
      regex: GlobalConstants.TEXT.CATEGORYMANAGE.REGEX,
      saveConfirmation: GlobalConstants.TEXT.CATEGORYMANAGE.SAVECONFIRMATION
    };
  }

  get isCategoryManage() {
    return appModule.isCategoryManage;
  }

  set isValid(state: boolean) {
    appModule.updateIsValid(state);
  }

  get isValid() {
    return appModule.isValid;
  }

  get inputIndex() {
    return appModule.inputIndex;
  }

  /** Methods **/

  private deleteCategory(idx: number) {
    this.isDeleteIndex = idx;
    const state = appModule.isCategoryManage[idx]?.state ?? false;
    appModule.updateIsCategoryManage({state: !state, idx});
  }

  private undoCategory(idx: number) {
    this.isDeleteIndex = idx;
    const state = appModule.isCategoryManage[idx]?.state ?? false;
    appModule.updateIsCategoryManage({state: !state, idx});
  }

  private async onCategoryName(val: string, idx: number) {
    appModule.updateInputIndex(idx);
    await this.$nextTick();
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
    appModule.updateCategoryManageName({val, idx});
  }

  private async onCategoryType(val: string, idx: number) {
    appModule.updateInputIndex(idx);
    await this.$nextTick();
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
    appModule.updateCategoryManageType({val, idx});
  }

  private async onBlur(ev: Event, idx: number) {
    await this.$nextTick();
    (this.$refs.form as Vue & { validate: () => boolean }).validate();
  }

  private add() {
    appModule.updateIsValid(false);
    const maxId = _.maxBy(appModule.categoryManageInfo, 'category_id');
    const param = {
      category_id: maxId ? maxId.category_id + 1 : 0,
      category_name: '',
      category_type: '',
      category_order: maxId ? maxId.category_order + 1 : 0,
      deleted: false,
    };
    appModule.updateAddCategoryManageInfo(param);
  }

  private async save(idx: number) {
    const checkName = _.filter(appModule.categoryManageInfo, {category_name: ''});
    const checkType = _.filter(appModule.categoryManageInfo, {category_type: ''});
    const check = checkName.length === 0 && checkType.length === 0;
    // 内容をチェックして問題なければ保存処理
    if (check) {
      const convert = this.keysToCamel(appModule.categoryManageInfo);
      await appModule.updateIsConfirmationDialog({
        type: 'categoryManageSave',
        state: true,
        title: `${this.text.title}`,
        message: `${this.text.saveConfirmation}`,
        data: convert as unknown as PUCATDataReq[]
      });
    }
  }

  private keysToCamel(o: any): any {
    const isObject = (oo: any) => {
      return oo === Object(oo) && !isArray(oo) && typeof oo !== 'function';
    };
    const isArray = (a: any) => {
      return Array.isArray(a);
    };
    const toCamel = (s: any) => {
      return s.replace(/([-_][a-z])/ig, ($1: any) => {
        return $1.toUpperCase()
          .replace('-', '')
          .replace('_', '');
      });
    };
    if (isObject(o)) {
      const n: { [key: string]: any } = {};

      Object.keys(o)
      .forEach((k: string) => {
        n[toCamel(k)] =  this.keysToCamel(o[k]);
      });

      return n;
    } else if (isArray(o)) {
      return o.map((i: any) => {
        return this.keysToCamel(i);
      });
    }

    return o;
  }

  /** Watch **/
  @Watch('isCategoryManage', { deep: true })
  private onIsCategoryManage() {
    appModule.updateCategoryManageDelete({state: appModule.isCategoryManage[this.isDeleteIndex].state, idx: appModule.isCategoryManage[this.isDeleteIndex].idx});
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/

  private async mounted() {
    appModule.startLoading();
    const token = this.$route.query.token ?? userModule.apiToken;
    contentsService.setBreadcrumb(this.$route.path, 'categorymanage', null, null, null, null, `${token}`);
    await appModule.requestCategoryManageInfo({
      q: '',
      s: 0,
      o: 'dp'
    })
    .catch(err => {
      this.errorPropagation(err);
    });
    appModule.updateInitIsCategoryManage(_.map(appModule.categoryManageInfo, (num: any, idx: number) => ({state: false, idx})));
    appModule.stopLoading();
  }

}
